import {RouteConfig} from 'vue-router';
import ChallengeDetails from '@/components/Challenges/ChallengeDetails.vue';
import Challenges from '@/components/Challenges/Challenges.vue';
import {challengeTabsRoutes} from '@/routes/challenge-tabs.router';
import {challengesByStatusRoutes} from '@/routes/challenges-by-status.router';

export const challengerRoutes: RouteConfig[] = [
  {
    path: '',
    component: Challenges,
    children: challengesByStatusRoutes,
  },
  {
    path: ':slug',
    component: ChallengeDetails,
    children: challengeTabsRoutes,
  },
];
